import comp from "./CycleCard";
export default comp;
